import {Localize} from "@dp-instant/i18n";
import {ComponentClassName, useInjection, visibilityEffect} from "@dp-instant/ui";
import {PlayerColor} from "@game/coregame/settings";
import {ShopType} from "@game/ui/constants";
import {SVG} from "@game/ui/images";
import cn from "classnames";
import {BuildingItem} from "@game/ui/components/Shop/BuildingItem/BuildingItem";
import {FighterItem} from "@game/ui/components/Shop/FighterItem/FighterItem";
import {ColorItem} from "@game/ui/components/Shop/ColorItem";
import {GameModel} from "@game/coregame/model/GameModel";
import {TypesGame} from "@game/TypesGame";

export type ShopItemProps = {
    id?: any;
    colorClassName?: string;
    onClick?: (e: any) => void;
    isSelected?: boolean;
    stored?: boolean;
    textureUrl?: string;
    selectedColorSet?: PlayerColor | undefined;
    type?: ShopType;
    colorData?: PlayerColor | undefined;
    forCoins?: number;
} & ComponentClassName;

const ShopItemPrice = () => (
    <div className="shop-item__price">
        <div className="shop-item__price-text">
            <span>{Localize.get("ui-fillbox-get", "GET")}</span>
        </div>
        <div className="shop-item__price-video-icon">
            {__SOCIAL__ === "tg" ? <span>⭐</span> : <SVG.Video />}
        </div>
    </div>
);

const ShopItemCoinsPrice = ({price}: {price?: number}) => {
    return (
        <div className="shop-item__price">
            <div className="shop-item__price-text">
                <span>{price || 5000}</span>
            </div>
            <div className="shop-item__price-video-icon for-coins">
                <SVG.COINS />
            </div>
        </div>
    );
};

export const ShopItem = ({
    colorClassName = "",
    className = "",
    isSelected = false,
    onClick = () => {},
    stored = false,
    textureUrl = "",
    selectedColorSet = undefined,
    type = ShopType.COLOR,
    colorData = undefined,
    forCoins = undefined
}: ShopItemProps) => {
    const [invisible] = visibilityEffect(200);

    const model = useInjection<GameModel>(TypesGame.model);

    return (
        <div
            onClick={onClick}
            className={cn("shop-item", className, {invisible, "shop-item_selected": isSelected})}
        >
            <div className={"shop-item__overlay"}></div>
            {type === ShopType.COLOR ? (
                <ColorItem colorData={colorData} />
            ) : type === ShopType.BUILDING ? (
                <BuildingItem
                    textureUrl={textureUrl}
                    className={colorClassName}
                    playerColor={selectedColorSet}
                />
            ) : (
                <FighterItem
                    textureUrl={textureUrl}
                    className={colorClassName}
                    playerColor={selectedColorSet}
                />
            )}

            <div className={cn("shop-item-icon", {"shop-item-icon_selected": isSelected})}></div>
            {stored ? null : !!forCoins && !model.rewardedAdsAllowed ? (
                <ShopItemCoinsPrice price={forCoins} />
            ) : (
                <ShopItemPrice />
            )}
        </div>
    );
};
